// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile .page__header h1{text-shadow:0px 2px 2px rgba(0,0,0,.537254902)}@media only screen and (min-width: 1281px){.profile .page__header img.bannerImg{height:400px}}@media only screen and (max-width: 1280px){.profile .page__header img.bannerImg{height:180px}}.profile-container{max-width:100% !important;padding:0 8% 0 8%}@media only screen and (max-width: 575px){.profile-container{padding:0 24px 0 24px}}", ""]);
// Exports
module.exports = exports;
